export default {"src":"/_next/static/media/google-logo.5832f49f.svg","height":18,"width":19,"blurWidth":0,"blurHeight":0};